import React from 'react';
import ReviewHeader from '../../../review/reviewHeader/ReviewHeader';
import styles from './FullbleedImgSection.module.scss';
import {
  fullBleedImg,
  fullBleedImgSm,
  fullBleedImgmd,
} from '../../../../../src/images';

const FullbleedImgSection = ({ id }) => {
  const Content = {
    img: {
      small: fullBleedImgSm,
      medium: fullBleedImgmd,
      large: fullBleedImg,
    },
    mainTitle: `${'Relief Factor is a 100% drug-free daily supplement that works safely with your body long-term.'}`,
  };
  const isFullBleedSection = true;
  return (
    <>
      <div className={styles.fullBleedImgExtender} id={id}>
        <div className={styles.fullContainer}>
          <ReviewHeader
            content={Content}
            className={styles.FullbleedImgSection}
            isFullBleedSection={isFullBleedSection}
          />
        </div>
      </div>
    </>
  );
};

export default FullbleedImgSection;
